import { asMarionetteView } from "lib/common/hoc/BackboneReact/asMarionetteView";
import BottomPane from "./views/BottomPane";
import VerticalResizableLayout
    from "lib/common/resizable/VerticalResizableLayout";
import { FluxEntityHeader as EntityHeader } from "./views/EntityHeader";
import ColumnNavigator from "./views/ColumnNavigator";
import hybridConfig from "lib/HybridConfig";
import { FluxBreadcrumbNavigator as BreadcrumbNavigator } from "./views/BreadcrumbNavigator";

const MarionetteEntityHeader = asMarionetteView(EntityHeader);
const MarionetteColumnNavigator = asMarionetteView(ColumnNavigator);
const MarionetteBreadcrumbNavigator = asMarionetteView(BreadcrumbNavigator);
//const MarionetteBottomPane = asMarionetteView(BottomPane);

class DataEntryFormModule extends VerticalResizableLayout {
    constructor(...args) {
        super(...args);
        this.initialize = this.initialize.bind(this);
        this.onRender = this.onRender.bind(this);
        this.showForm = this.showForm.bind(this);
    }

    initialize(options) {
        this.fluxContext = options.fluxContext;
        this.isModal = options.isModal;
        this.showTreeNavigator = hybridConfig.get(
            "ui.showTreeNavigator",
            false,
        );
        this.showEntityNavigator = hybridConfig.get(
            "ui.showEntityNavigator",
            true,
        );
    }

    onRender() {
        const fluxContext = this.fluxContext;
        if (this.showTreeNavigator) {
            this.header.show(new MarionetteBreadcrumbNavigator({
                fluxContext,
            }));
        } else {
            this.header.show(new MarionetteEntityHeader({
                fluxContext,
            }));
        }

        if (this.showEntityNavigator) {
            this.topPaneView = new MarionetteColumnNavigator({
                fluxContext,
            });
            this.topPane.show(this.topPaneView);
        } else {
            // this is here to hide the EntityNavigator
            this.resize(52);
            this.$(".slider-wrapper").remove();
        }

        this.bottomPaneView = new BottomPane({
            fluxContext,
            showTreeNavigator: this.showTreeNavigator,
            isModal: this.isModal,
        });
        this.bottomPane.show(this.bottomPaneView);

        //rebind dom events after replacing contents
        this.delegateEvents();

    }

    showForm() {
        if(this.bottomPaneView) {
            this.bottomPaneView.showForm();
        }
    }
}

DataEntryFormModule.prototype.className = "data-entry";

export default DataEntryFormModule;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/DataEntryFormModule.js